module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "message-bubble.7692c3c9.svg";